import type { jsPDF } from 'jspdf'

/**
 * Adds a professional, semi-transparent "MtuPori" watermark diagonally across all pages of a jsPDF document.
 * 
 * @param doc The jsPDF document instance
 * @param watermarkText The text to render as watermark (defaults to "MtuPori")
 */
export function addPdfWatermark(doc: jsPDF, watermarkText = 'MtuPori'): void {
  try {
    const totalPages = (doc as any).internal.getNumberOfPages()

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i)
      const pageWidth = doc.internal.pageSize.width
      const pageHeight = doc.internal.pageSize.height
      const isLandscape = pageWidth > pageHeight

      // Save graphics state if supported to avoid affecting subsequent elements
      if (typeof (doc as any).saveGraphicsState === 'function') {
        (doc as any).saveGraphicsState()
      }

      // Calculate proportional font size (subtle & non-intrusive)
      const minDim = Math.min(pageWidth, pageHeight)
      const fontSize = Math.round(minDim * 0.16)

      doc.setFontSize(fontSize)
      // Ultra-light soft grey tint
      doc.setTextColor(232, 236, 242)
      doc.setFont('helvetica', 'bold')

      // Set low alpha opacity if GState is available
      try {
        if ((doc as any).GState) {
          doc.setGState(new (doc as any).GState({ opacity: 0.08 }))
        }
      } catch {
        // Fallback to light text color
      }

      // Center coordinates
      const centerX = pageWidth / 2
      const centerY = pageHeight / 2

      // Render rotated text centered
      doc.text(watermarkText.toUpperCase(), centerX, centerY, {
        align: 'center',
        baseline: 'middle',
        angle: isLandscape ? 30 : 45
      } as any)

      // Restore graphics state
      if (typeof (doc as any).restoreGraphicsState === 'function') {
        (doc as any).restoreGraphicsState()
      }
    }
  } catch (err) {
    console.warn('Failed to render PDF watermark:', err)
  }
}
